import { createContext, FC, useContext } from 'react'
import { WithChildren } from '../../../_metronic/helpers'
import { ReportBonusSaleConfig } from './ReportBonusSaleConfig'

const ReportConfigContext = createContext<ReportBonusSaleConfig>({} as ReportBonusSaleConfig)

const ReportConfigProvider: FC<WithChildren & { config: ReportBonusSaleConfig }> = ({ children, config }) => {
  return (
    <ReportConfigContext.Provider value={config}>
      {children}
    </ReportConfigContext.Provider>
  )
}

const useReportConfig = () => useContext(ReportConfigContext)

export { ReportConfigProvider, useReportConfig }
